<template>
  <div class="pwc-self-info">
    <van-nav-bar title="个人资料" left-arrow fixed @click-left="handleReturn" />

    <pwc-container>
      <van-cell-group :border="false">
        <van-cell title="头像" value="内容" :center="true">
          <pwc-avatar class="pwc-self-avatar" :upload="handleUpdateAvatar" :avatar="userInfo.profilePhotoUrl" />
        </van-cell>
        <van-cell title="昵称" :value="userInfo.name" is-link @click="handleUpdate('昵称',userInfo.name, 'name')" />
        <van-cell title="年龄" :value="cAge" is-link @click="handleUpdate('年龄',userInfo.age, 'age', 'ageRange', 1)" />
        <van-cell title="邮箱" :value="userInfo.email" is-link @click="handleUpdate('邮箱',userInfo.email, 'email')" />
      </van-cell-group>

      <van-cell-group v-if="cShowEducation" :border="false" class="pwc-self-education">
        <van-cell title="学校" :value="userInfo.eduInstitution" is-link @click="handleUpdate('学校',userInfo.eduInstitution,'eduInstitution')" />
        <van-cell title="年级" :value="cGrade" is-link @click="handleUpdate('年级',userInfo.grade, 'grade', 'anchorStudentGrades', 1)" />
        <van-cell title="专业" :value="userInfo.major" is-link @click="handleUpdate('专业',userInfo.major, 'major')" />
      </van-cell-group>
      <van-cell-group v-if="cShowWorkInfo" :border="false" class="pwc-self-work">
        <van-cell title="公司" :value="userInfo.company" is-link @click="handleUpdate('公司',userInfo.company, 'company')" />
        <van-cell title="职位" :value="userInfo.title" is-link @click="handleUpdate('职称',userInfo.title, 'title')" />
        <van-cell title="工作年限" :value="cWorkYear" is-link @click="handleUpdate('工作年限',userInfo.yearsOfWork, 'yearsOfWork', 'workYearRange', 1)" />
        <van-cell title="行业" :value="cIndustry" is-link @click="handleUpdate('行业',userInfo.industryId, 'industryId', 'industries', 1)" />
        <van-cell v-if="cIndustry==='其他'" title="" :value="userInfo.industryOther" is-link @click="handleUpdate('行业其他',userInfo.industryOther, 'industryOther')" />
      </van-cell-group>
      <van-cell-group v-if="cShowWorkInfo" :border="false" class="pwc-self-work">
        <van-cell title="推荐人ID" :value="userInfo.refererId" is-link @click="handleUpdate('推荐人ID',userInfo.refererId, 'refererId')" />
        <van-cell title="推荐人姓名" :value="userInfo.refererName" is-link @click="handleUpdate('推荐人姓名',userInfo.refererName, 'refererName')" />
      </van-cell-group>
      <van-cell-group :border="false" class="pwc-self-address">
        <van-cell title="项目类型" :value="userInfo.programmeTypeName" />
        <van-cell title="手机号码" :value="userInfo.phone" />
      </van-cell-group>
      <van-cell-group
        title="简历"
        :border="false"
        class="pwc-self-worker"
      >
        <pwc-upload-resume
          :uploaddoclist="cfileList"
          :maxfcnt="1"
        />
      </van-cell-group>
    </pwc-container>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RouterName from '@/constants/route'
import PwcAvatar from '@/components/PwcAvatar'
import { upload } from '@/mixin/file'
import Actions from '@/constants/action'
import { ProgrammeType } from '@/constants/type'
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import PwcUploadResume from '@/components/PwcUploadResume'

import { CellGroup, Cell, NavBar } from 'vant'

export default {
  components: {
    VanCellGroup: CellGroup,
    VanCell: Cell,
    VanNavBar: NavBar,
    PwcContainer,
    PwcUploadResume,
    PwcAvatar
  },
  mixins: [upload],
  data() {
    return {
      cvDir: ''
    }
  },
  computed: {
    ...mapState(['userInfo', 'lookups']),
    cfileList() {
      if (this.userInfo.resumes && this.userInfo.resumes.length > 0) {
        const files = this.userInfo.resumes.map(r => {
          return { file: { name: decodeURI(r.item1), url: r.item2 }}
        })

        return files
      }
      return []
    },
    cShowEducation() {
      return this.userInfo.programmeType === ProgrammeType.Anchor
    },
    cShowWorkInfo() {
      return this.userInfo.programmeType === ProgrammeType.YouPlus
    },
    cAge() {
      const obj = (this.lookups.ageRange || []).find(v => v.id === this.userInfo.age)
      if (obj) {
        return obj.name
      }
      return this.age
    },
    cGrade() {
      const obj = (this.lookups.anchorStudentGrades || []).find(v => v.id === this.userInfo.grade)
      if (obj) {
        return obj.name
      }
      return this.grade
    },
    cWorkYear() {
      const obj = (this.lookups.workYearRange || []).find(v => v.id === this.userInfo.yearsOfWork)
      if (obj) {
        return obj.name
      }
      return this.yearsOfWork
    },
    cIndustry() {
      const obj = (this.lookups.industries || []).find(v => v.id === this.userInfo.industryId)
      if (obj) {
        return obj.name
      }
      return this.industryId
    }
  },
  created() {
    this.fetchLookups()
  },
  methods: {
    ...mapActions({
      updateAvatar: Actions.UPDATE_AVATAR,
      fetchLookups: Actions.GET_LOOKUP
    }),
    handleReturn() {
      this.$router.replace({
        name: RouterName.home,
        query: {
          active: 'self'
        }
      })
    },
    handleUpdate(name, value, prop, lookupName = '', tp = 0) {
      this.$router.replace({
        name: RouterName.update,
        query: {
          name: name,
          message: value,
          prop: prop,
          lookupName: lookupName,
          type: tp,
          from: RouterName.selfInfo
        }
      })
    },
    handleUpdateAvatar(e, dir, isPublic) {
      this.uploadFile(e, dir, isPublic)
        .then(key => {
          return this.updateAvatar({
            item: key
          })
        })
    },
    async handleSelect(e) {
      this.uploading = true
      this.uploadFile(e, '', false)
        .then(key => {
          return key
        }
        )

      this.uploading = false
    }
  }
}
</script>

<style lang="scss" scoped>
$pwc-avatar-size:80px;
.pwc-self-info {
  .pwc-self-avatar {
    float: right;
    box-shadow: none;
  }
  .pwc-self-address,
  .pwc-self-education,
  .pwc-self-work {
    margin-top: 6px;
  }
}

.pwc-file-upload{
  box-sizing: border-box;
  margin: 4px;
  //background-image: url('./assets/camera.png');
  background-size: 50% 50%;
  background-position: center;
  background-repeat: no-repeat;
  position:relative;
  height:$pwc-avatar-size;
  width:$pwc-avatar-size;
  border-radius: 50%;
  overflow:hidden;
  display:flex;
  justify-content:center;
  align-items: center;
  border:4px solid #fff;
  box-shadow: inset 0 1.5px 3px 0 rgba(0,0,0,.15), 0 1.5px 3px 0 rgba(0,0,0,.15);

  input[type='file']{
    position:absolute;
    height:$pwc-avatar-size;
    width:$pwc-avatar-size;
    top:0;
    left:0;
    opacity:0;
    cursor:pointer;
  }
  img {
    height: 80px;
    width: 80px;
  }
  }
</style>
